"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmEmailErrorMessage = exports.confirmLoginErrorMessage = void 0;
exports.confirmLoginErrorMessage = "Since this is the first time you are logging from this device, we have sent you an email to confirm it's you. Follow the instructions in the email to log in.";
// Shown when an account that has never confirmed its signup email tries to log
// in. We (re)send the confirmation link, then block the login until the inbox
// is verified. Matched by string (not error code) on the frontend, the same way
// confirmLoginErrorMessage is — see AccountService.login and AuthStore.logIn.
exports.confirmEmailErrorMessage = "Please confirm your email address to continue. We've sent a confirmation link to your inbox — follow it to finish logging in.";
//# sourceMappingURL=login_helper.js.map